@if (isReadOnly) {
  <mat-form-field disabled class="availability-marginright">
    <mat-label>Field</mat-label>
    <input matInput [(ngModel)]="item.PropertyName" required disabled />
  </mat-form-field>
}

@if (!isReadOnly) {
  <mat-form-field class="availability-marginright">
    <mat-label>Field</mat-label>
    <mat-select id="aw_availability_field" matInput [(ngModel)]="item.PropertyName" required [disabled]="isReadOnly" (selectionChange)="conditionFieldChanged()">
      @for (field of availabilityService.conditionFields; track field) {
        <mat-option [value]="field.FieldId">{{ prettifyLabel(field.FieldName) }}</mat-option>
      }
    </mat-select>
    @if (!item.PropertyName) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>
}

<mat-form-field class="availability-marginright">
  <mat-label>Operator</mat-label>
  <mat-select id="aw_availability_operator" matInput [(ngModel)]="item.ValueIs.Identifier" required [disabled]="isReadOnly" (selectionChange)="identifierFieldChanged()">
    @for (identifier of identifiers; track identifier) {
      <mat-option [value]="identifier.Value">{{ identifier.Text }}</mat-option>
    }
  </mat-select>
  @if (!item.ValueIs.Identifier) {
    <mat-error>Required</mat-error>
  }
</mat-form-field>

@if (selectedFieldType === 'list' && !isMultiple) {
  <mat-form-field class="availability-marginright">
    <mat-label>Value</mat-label>
    <mat-select id="aw_availability_value" matInput [(value)]="item.ValueIs.Value" [disabled]="isReadOnly" [required]="selectedFieldType === 'list' && !isMultiple" (selectionChange)="valueFieldChanged()">
      @for (valueOption of valueOptions; track valueOption) {
        <mat-option [value]="valueOption.Value">{{ valueOption.Text }}</mat-option>
      }
    </mat-select>
    @if (!item.ValueIs.Value) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>
}

@if (selectedFieldType === 'list' && isMultiple) {
  <mat-form-field class="availability-marginright">
    <mat-label>Value</mat-label>
    <mat-select id="aw_availability_value" matInput [(value)]="item.ValueIs.Value" [disabled]="isReadOnly" multiple [required]="selectedFieldType === 'list' && isMultiple" (selectionChange)="valueFieldChanged()">
      @for (valueOption of valueOptions; track valueOption) {
        <mat-option [value]="valueOption.Value">{{ valueOption.Text }}</mat-option>
      }
    </mat-select>
    @if (!item.ValueIs.Value) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>
}

@if (selectedFieldType === 'checkbox') {
  <div class="availability-marginright">
    <mat-checkbox id="aw_availability_value" [(ngModel)]="item.ValueIs.Value" [disabled]="isReadOnly" aria-label="Value"></mat-checkbox>
  </div>
}

@if (selectedFieldType === 'text') {
  <mat-form-field class="availability-marginright">
    <mat-label>Value</mat-label>
    <input id="aw_availability_value" matInput [(ngModel)]="item.ValueIs.Value" required [disabled]="isReadOnly" (change)="valueFieldChanged()" />
  </mat-form-field>
}

@if (!isReadOnly) {
  <button id="aw_availability_delete" mat-button (click)="onDeleteButtonClick()">
    <mat-icon>delete</mat-icon>
  </button>
}

@if (isReadOnly) {
  <div class="read-only-message">[The above condition doesn't map to a known field - it can only be modifed in the Best Practices definition in code]</div>
}